globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.OptimizationController = (function(superClass) {

    utils.extend(OptimizationController, superClass);

    function OptimizationController() {
        return OptimizationController.__super__.constructor.apply(this, arguments);
    }

    $.extend(OptimizationController.prototype, {
        init: function(){
          if($('.optimization-report-content').find("input#find_address").length){
            this._initAddress();
          }

          this.initEvents();

          return OptimizationController.__super__.init.apply(this, arguments);
        },
        _initAddress: function(){
          $inputGeocoder = $('.optimization-report-content').find("input#find_address");

          $inputGeocoder.addresspicker({
            apiKey: helpers.google.api.key,
            elements: {
              map: '#accounts_business_location_address_map',
              lat: '#accounts_business_location_address_latitude',
              lng: '#accounts_business_location_address_longitude',
              postal_code: '#accounts_business_location_address_postal_code',
              locality: '#accounts_business_location_address_city_name',
              country: '#accounts_business_location_address_country',
              country_code: '#accounts_business_location_address_region_code'
            },
            mapOptions: { zoom: 15 },
            draggableMarker: !$inputGeocoder.prop('disabled'),
            reverseGeocode: !$inputGeocoder.prop('disabled')
          });
        },
        initEvents: function(){
          var $html = $('.optimization-report-content');

          $html.on('submit', '.manage-criteria-feedback-form', function(e){
            var $submittedForm = $(this);
            e.preventDefault();
            appCustomerSpace.Loader().start({ $container: $submittedForm.closest('.criteria-panel'), options: {text: false, style: { backdrop: { background: 'rgb(255,255,255,0.8)' }}} });

            var $pageHeader = $submittedForm.closest('.content-wrapper').find('.page-header');
            var $secondaryNavigation = $submittedForm.closest('.main-content-container').find('.secondary-navigation');

            $.ajax({
              url: $submittedForm.attr('action'),
              method: $submittedForm.attr('method'),
              data: $submittedForm.serialize(),
              success: function(data){
                if(data.response == 1) {
                  if(data.html){
                    setTimeout(function(){
                      var $currentPageContentScore = $submittedForm.closest('.optimization-report-content').find('.optimization-score');
                      var $currentPageHeaderScore = $pageHeader.find(`.optimization-score-level-${data.level}`);
                      var $secondaryNavigationScore = $secondaryNavigation.find('.optimization-score-in-navigation');

                      $currentPageContentScore.html(data.html['tab_content_thumbnail']);
                      $currentPageHeaderScore.html(data.html['level_score_thumbnail']);
                      $secondaryNavigationScore.html(data.html['secondary_navigation_thumbnail']);

                      $submittedForm.closest('.criteria-panel').html(data.html['criteria_thumbnail']);

                      appCustomerSpace.Plugins.initPlugins();
                      appCustomerSpace.LimitlessPlugins.initPlugins();
                      OptimizationController.prototype._initAddress();

                      appCustomerSpace.Loader().stop();
                    }, 200);
                  }
                } else {
                  appCustomerSpace.Loader().stop();
                }
              },
              error: function(data){
                alert('Une erreur est survenue');
              }
            });
          });
        }
    });

    return OptimizationController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
